export default "__VITE_ASSET__ClRiQUWv__"